module.exports = __webpack_public_path__ + "static/media/landing.cffe451d.png";